import { Input, ViewContainerRef, Directive, AfterViewInit, ElementRef, inject, HostListener } from '@angular/core';
import { BooktechAppService } from '../services/booktech-app.service';

@Directive({
  selector: '[copyPlainText]',
  standalone: true,
})
export class CopyPlainTextDirective {
  bas = inject(BooktechAppService);

  @HostListener('copy', ['$event'])
  onCopy(e: ClipboardEvent) {
    const sel = window.getSelection();
    if (!sel || !e.clipboardData) return;
    const text = sel.toString();
    e.clipboardData.setData('text/plain', text);

    // const container = document.createElement('div');
    // for (let i = 0; i < sel.rangeCount; i++) {
    //   const range = sel.getRangeAt(i);
    //   container.appendChild(range.cloneContents());
    // }
    // const html = container.innerHTML; 

    // if (this.bas.envtest) console.log("CopyPlainTextDirective.onCopy text: " + text + ", html: " + html);
    // valgfritt: fjern HTML så ikke noe annet blir med
    // e.clipboardData.setData('text/html', text.replace(/</g, '&lt;').replace(/>/g, '&gt;'));
    e.preventDefault();
  }
}

